import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { EdwardColors } from 'enums';
import { borderRadiusBox } from 'components/AppTheme/index';

interface MenuProps {
  header?: boolean;
  insite?: boolean;
  userMode?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: MenuProps) => ({
      background: theme.palette.common.black,
      padding: theme.spacing(1, 1, 1, 1),
      position: 'relative',
      display: props.header ? 'none' : undefined,
      transition: '0.5s all',
      '&:before': {
        content: '""',
        borderTop: `solid ${EdwardColors.DARKER} 3px`,
        display: 'inline-block',
        position: 'absolute',
        left: 0,
        top: 0,
        width: 'calc(100% - 16px)',
        margin: theme.spacing(0, 1),
        transition: '0.5s all',
        //position: 'absolute'
      },

      '&.closed': {
        padding: theme.spacing(1, 0, 1, 0),
        '&:before': {
          borderTopColor: 'transparent',
        },
        [theme.breakpoints.down('xs')]: {
          padding: 0,
          border: 0,
        },
      },
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        flexBasis: '0',
        '&:before': {
          display: 'none',
        },
      },
    }),
    userMenu: (props: MenuProps) => ({
      '& .MuiPaper-root': {
        background: theme.palette.common.black,
        color: EdwardColors.GRAY_LIGHTER,
        '& svg': { color: EdwardColors.GRAY_LIGHTER },
      },
      [theme.breakpoints.down('xs')]: {
        '& .MuiPaper-root': {
          marginLeft: theme.spacing(2),
          width: '100%',
          maxWidth: '100%',
          marginTop: props.userMode ? '1px' : '-29px',
        },
      },
    }),
    userMenuItem: {
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(6),
      },
    },
    title: {
      color: EdwardColors.DARKER,
      cursor: 'default',
      borderTop: `solid ${EdwardColors.DARKER} 3px`,
      transition: 'all 250ms',
      overflow: 'hidden',
      '& .MuiListItemText-root': { opacity: 1, transition: 'all 250ms' },
      '& .MuiListItemIcon-root': {
        color: EdwardColors.DARKER,
        minWidth: 0,
        width: 0,
        transition: 'all 250ms',
        overflow: 'hidden',
      },
    },
    titleClosed: {
      '& .MuiListItemText-root': { opacity: 0 },
      borderColor: 'transparent',
      '& .MuiListItemIcon-root': {
        width: theme.spacing(4),
      },
    },
    titleNoDivider: {
      borderTop: `solid transparent 3px`,
    },
    item: {
      color: EdwardColors.GRAY_LIGHTER,
      borderRadius: borderRadiusBox,
      '&:hover': {
        backgroundColor: EdwardColors.GRAY_MEDIUM,
        color: theme.palette.common.white,
        '& svg': {
          color: theme.palette.common.white,
        },
      },
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(6),
      },
      '& .MuiListItemText-primary': {
        display: 'flex',
        justifyContent: 'space-between',
        '& > span': { height: theme.spacing(3) }
      },
      [theme.breakpoints.down('xs')]: {
        background: 'transparent',
        padding: 0,
        '&:hover': {
          background: 'transparent',
        },
      },
    },
    divider: {
      borderTop: 'solid #ccc 1px',
    },
    dropdown: (props: MenuProps) => ({
      background: 'transparent',
      padding: props.header ? theme.spacing(0, 1) : 0,
      margin: 0,
      zIndex: 1000,
      '& .MuiMenuItem-root': {
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .MuiListItemIcon-root': {
        width: 40,
        height: 40,
        margin: 0,
        '& > svg': {
          width: '100%',
          height: '100%',
          color: props.header ? theme.palette.primary.light : undefined,
        },
      },
      '& > li': {
        background: 'transparent',
      },
    }),
    selected: {
      '& .MuiTypography-body1': { fontWeight: 500 },
      color: theme.palette.common.white,
      '& svg': {
        color: `${theme.palette.common.white} !important`,
      },
      backgroundColor: EdwardColors.GRAY_DARKER,
      [theme.breakpoints.down('sm')]: {
        backgroundColor: EdwardColors.GRAY_DARKER,
      },
      '&:hover': {
        backgroundColor: EdwardColors.GRAY_DARKER,
      },
    },
    activeFlow: {
      color: EdwardColors.DARK,
      '& svg': {
        color: `${EdwardColors.DARK} !important`,
      },
      '&:hover': {
        color: EdwardColors.DARK,
        '& svg': {
          color: `${EdwardColors.DARK} !important`,
        },
      },
    },
    icon: {
      color: EdwardColors.GRAY_LIGHTER,
      [theme.breakpoints.down('sm')]: {
        minWidth: '32px',
      },
    },
    advisorInfo: {
      position: 'relative',
      transition: '0.5s borderColor',
      '& > div, & > button': { transition: '0.5s opacity' },
      borderTop: `solid ${EdwardColors.DARKER} 3px`,
      padding: theme.spacing(1),
      margin: theme.spacing(0, 1),
      lineHeight: '1.8',
      color: EdwardColors.GRAY_LIGHTER,
      '& h3': {
        color: EdwardColors.DARK,
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
      width: '234px',
      '&.closed': { borderTopColor: 'transparent' },
      '&.open > div': { opacity: 1 },
      '&.closed > div': { opacity: 0 },
      '&.open > button': { opacity: 0, zIndex: 0 },
      '&.closed > button': { opacity: 1, zIndex: 1 },
    },
    openClose: {
      justifyContent: 'end',
      paddingBottom: theme.spacing(2),
      '&:hover': { background: 'transparent' },
      '& .MuiTouchRipple-root': {
        maxWidth: '56px',
        left: 'auto',
      },
      '& .MuiListItemIcon-root': {
        minWidth: 0,
      },
    },
    close: {
      justifyContent: 'end',
      '& .MuiListItemIcon-root': {
        justifyContent: 'end',
        '& svg': { color: EdwardColors.DARK },
      },
    },
  }),
);

export default useStyles;
